import React from 'react';
import './Skills.css';

const Skills: React.FC = () => {
  const skillCategories = [
    {
      title: "Backend Technologies",
      skills: [
        { name: "Node.js", level: 95 },
        { name: "TypeScript", level: 90 },
        { name: "Express.js", level: 90 },
        { name: "FeathersJS", level: 85 },
        { name: "JWT & Authentication", level: 90 }
      ]
    },
    {
      title: "Databases & Data",
      skills: [
        { name: "MongoDB", level: 95 },
        { name: "Elasticsearch", level: 85 },
        { name: "DynamoDB", level: 80 },
        { name: "Redis/ElastiCache", level: 75 },
        { name: "Realm-sync", level: 80 }
      ]
    },
    {
      title: "AWS Cloud Services",
      skills: [
        { name: "EC2 & VPC", level: 90 },
        { name: "Lambda & API Gateway", level: 85 },
        { name: "S3 & CloudFront", level: 90 },
        { name: "SQS & SES", level: 85 },
        { name: "CloudWatch & IAM", level: 80 }
      ]
    },
    {
      title: "DevOps & Tools",
      skills: [
        { name: "CodeBuild & CodePipeline", level: 85 },
        { name: "CloudFormation", level: 80 },
        { name: "RabbitMQ", level: 85 },
        { name: "Docker", level: 75 },
        { name: "CI/CD", level: 85 }
      ]
    },
    {
      title: "AI & Modern Tech",
      skills: [
        { name: "Computer Vision", level: 80 },
        { name: "LangChain", level: 75 },
        { name: "OCR Systems", level: 80 },
        { name: "ML Pipeline", level: 75 },
        { name: "Object Detection", level: 75 }
      ]
    },
    {
      title: "Leadership & Management",
      skills: [
        { name: "Team Leadership", level: 90 },
        { name: "Technical Architecture", level: 95 },
        { name: "Project Management", level: 85 },
        { name: "Mentoring", level: 90 },
        { name: "Agile/OKRs", level: 85 }
      ]
    }
  ];

  return (
    <section id="skills" className="skills">
      <div className="container">
        <h2>Skills & Expertise</h2>
        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <div key={index} className="skill-category">
              <h3>{category.title}</h3>
              <div className="skills-list">
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className="skill-item">
                    <div className="skill-header">
                      <span className="skill-name">{skill.name}</span>
                      <span className="skill-percentage">{skill.level}%</span>
                    </div>
                    <div className="skill-bar">
                      <div 
                        className="skill-progress" 
                        style={{ width: `${skill.level}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
